<template>
  <div class="currency-select">
    <Select v-model="selectedVal" @on-change="handleChange" @on-select="handleSelect" :prefix="prefix" :disabled="disabled" transfer>
      <Option value="CNY">CNY</Option>
      <Option value="USD">USD</Option>
      <Option value="EUR">EUR</Option>
    </Select>
  </div>
</template>

<script>
export default {
  name: 'CurrencySelect',
  props: {
    value: {
      type: String,
      required: false
    },
    prefix: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      selectedVal: this.value
    }
  },
  methods: {
    handleChange (change) {
      this.$emit('input', this.selectedVal)
      this.$emit('update:value', this.selectedVal)
      this.$emit('on-change', change)
    },
    handleSelect (selected) {
      this.$emit('on-select', selected)
    }
  },
  watch: {
    value: function (newVal) {
      this.selectedVal = newVal
    }
  }
}
</script>
